import { resolveLanguage, type SupportedLangCode } from '@/application/i18n/language'

/**
 * Resolves the language a given article entity (investigation/lead/fact)
 * should be *spoken* in, mirroring the backend's field-by-field translation
 * fallback (`translation-resolver.ts`) but without any per-field indicator:
 * the read-aloud widget either speaks the current UI locale (when the whole
 * investigation subtree is translated into it, or it happens to be the
 * entity's own source language) or falls back wholesale to the entity's
 * source language.
 *
 * `entitySourceLocale` wins over `investigationSourceLocale` when set (a
 * lead/fact can be authored in a different language than its parent
 * investigation); both default to `'fr'` when absent, matching the
 * backend's own default.
 */
export function resolveContentLang(
  entitySourceLocale: string | null | undefined,
  investigationSourceLocale: string | null | undefined,
  uiLocale: SupportedLangCode,
  availableLocales: readonly SupportedLangCode[] | null | undefined,
): SupportedLangCode {
  const sourceLang = resolveLanguage(entitySourceLocale ?? investigationSourceLocale ?? 'fr')

  if (uiLocale === sourceLang || (availableLocales ?? []).includes(uiLocale)) {
    return uiLocale
  }

  return sourceLang
}
